import { SVGProps, Ref, forwardRef } from 'react';

export const GESize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect y={4} width={32} height={24} rx={4} fill="#EEEEEE" />
            <path d="M13.5 18.5V28h5v-9.5H32v-5H18.5V4h-5v9.5H0v5z" fill="#E8112D" />
            <path
                d="M7.658 23.658q.045.926.219 1.842a7 7 0 0 0-1.754 0q.174-.916.22-1.842-.928.045-1.843.219a7 7 0 0 0 0-1.754q.916.174 1.842.22a13.5 13.5 0 0 0-.219-1.843 7 7 0 0 0 1.754 0q-.174.916-.22 1.842.928-.045 1.843-.219a7 7 0 0 0 0 1.754q-.916-.175-1.842-.22"
                fill="#E8112D"
            />
            <path
                d="M25.877 25.5a13.5 13.5 0 0 1-.22-1.842q.928.044 1.843.219a7 7 0 0 1 0-1.754q-.916.174-1.842.22.045-.928.219-1.843a7 7 0 0 1-1.754 0q.174.916.22 1.842a13.4 13.4 0 0 1-1.843-.219c.072.582.072 1.171 0 1.754q.916-.174 1.842-.22a13.4 13.4 0 0 1-.219 1.843 7 7 0 0 1 1.754 0"
                fill="#E8112D"
            />
            <path
                d="M7.658 9.658q.045.926.219 1.842a7 7 0 0 0-1.754 0q.174-.916.22-1.842-.928.045-1.843.219a7 7 0 0 0 0-1.754q.916.174 1.842.22A13.5 13.5 0 0 0 6.123 6.5a7 7 0 0 0 1.754 0q-.174.916-.22 1.842.928-.045 1.843-.219a7 7 0 0 0 0 1.754q-.916-.175-1.842-.22"
                fill="#E8112D"
            />
            <path
                d="M25.877 11.5a13.5 13.5 0 0 1-.22-1.842q.928.044 1.843.219a7 7 0 0 1 0-1.754q-.916.174-1.842.22.045-.928.219-1.843a7 7 0 0 1-1.754 0q.174.916.22 1.842a13.4 13.4 0 0 1-1.843-.219c.072.582.072 1.171 0 1.754q.916-.174 1.842-.22a13.4 13.4 0 0 1-.219 1.843 7 7 0 0 1 1.754 0"
                fill="#E8112D"
            />
        </g>
    </svg>
));
GESize32Glyph.displayName = 'GESize32Glyph';
